import { CREATE, CREATE_SUCCEEDED, CREATE_FAILED } from "../types"

export const create = config => {
  return { type: CREATE, config }
}

export const createSuccess = (action, response) => {
  return { type: CREATE_SUCCEEDED, action, response, config: action.config }
}

export const createError = (action, error) => {
  return { type: CREATE_FAILED, action, error }
}
